import { Poker } from '@/components/common/poker';
import { IcoGameCard } from '@/modules/rwdGame/andarbahar/svg';
import {
    AndarBaharFirst3Pattern,
    convertFResult,
} from '@/utils/games/andarBahar';
import { useEffect, useState } from 'react';
import { GameResultCellProps } from '..';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BetRecordScroller } from '../../scroller/BetRecordScroller';
import { BetRecordPokerList } from '../../pokerList/BetRecordPokerList';

export const AndarBaharGameResult = (props: GameResultCellProps) => {
    const { summary } = props;

    const { t } = useTranslation();
    const [gameCard, setGameCard] = useState<number>(-1);
    const [cardsDealt, setCardsDealt] = useState<number>(-1);
    const [firstAndarCard, setFirstAndarCard] = useState<number>(-1);
    const [firstBaharCard, setFirstBaharCard] = useState<number>(-1);
    const [remainAndarCards, setRemainAndarCards] = useState<Array<number>>([]);
    const [remainBaharCards, setRemainBaharCards] = useState<Array<number>>([]);
    const [first3Pattern, setFirst3Pattern] = useState<number>(-1);

    const getCardContent = () => {
        const cards = summary.Result.split(',').map(s => Number(s));
        const andars: number[] = [];
        const bahars: number[] = [];
        for (let i = 1; i < cards.length; i++) {
            if (i % 2 == 1) {
                andars.push(cards[i]);
            } else {
                bahars.push(cards[i]);
            }
        }

        return {
            cardsDealt: cards.length - 1,
            andarCards: andars,
            baharCards: bahars,
        };
    };

    const getFirst3ResultPatternMessage = (): string => {
        let msg = '';
        switch (first3Pattern) {
            case AndarBaharFirst3Pattern.ABF3StraightFlush:
                msg = t('andar_bahar.straight_flush');
                break;
            case AndarBaharFirst3Pattern.ABF3Straight:
                msg = t('andar_bahar.straight');
                break;
            case AndarBaharFirst3Pattern.ABF3Flush:
                msg = t('andar_bahar.flush');
                break;
            case AndarBaharFirst3Pattern.ABF3None:
                msg = t('andar_bahar.no_win');
                break;
            default:
                msg = '';
        }
        return msg;
    };

    useEffect(() => {
        console.log(
            cardsDealt,
            firstAndarCard,
            firstBaharCard,
            remainAndarCards,
            remainBaharCards,
            first3Pattern
        );
    }, []);

    useEffect(() => {
        const cards = getCardContent();
        const result = convertFResult(BigInt(summary.WinSlot));

        setGameCard(result.GameCard);
        setCardsDealt(cards.cardsDealt);
        setFirstAndarCard(cards.andarCards[0]);
        setFirstBaharCard(cards.baharCards[0]);
        setRemainAndarCards(cards.andarCards.slice(1));
        setRemainBaharCards(cards.baharCards.slice(1));
        setFirst3Pattern(result.First3Result);
    }, [summary]);

    return (
        <div className="item-andar-bahar-game-result-container">
            <div className="andar-bahar-cards-dealt-section">
                <div className="title-and-pokers-wrapper">
                    <div className="andar-bahar-title">
                        <div className="andar-title">A</div>
                        <div className="bahar-title">B</div>
                    </div>
                    <BetRecordScroller gameType={summary.GameType}>
                        <BetRecordPokerList
                            decks={[remainAndarCards, remainBaharCards]}
                        />
                    </BetRecordScroller>
                </div>
                <Typography className="cards-dealt-text">
                    {`${t('andar_bahar.card_dealt')} ${cardsDealt}`}
                </Typography>
            </div>
            <div className="andar-bahar-first-three-cards-section">
                <div className="first-three-cards-wrapper">
                    <div className="first-two-cards">
                        <div className="first-andar-card">
                            <Poker n={firstAndarCard} />
                        </div>
                        <div className="first-bahar-card">
                            <Poker n={firstBaharCard} />
                        </div>
                    </div>
                    <GameCard card={gameCard} />
                </div>
                <div className="first-three-cards-pattern">
                    <Typography className="pattern-text">
                        {`${getFirst3ResultPatternMessage()}`}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

const GameCard = (props: { card: number }) => {
    const { card } = props;
    return (
        <div className="andar-bahar-game-card">
            <IcoGameCard className="svg" />
            <div className="game-card-wrapper">
                <Poker n={card} />
            </div>
            <IcoGameCard className="svg reverse" />
        </div>
    );
};
